import { SignInMode } from '../session';

export interface SignInAccountStartupContext {
  signInMode: SignInMode;
}

export type AccountStartupContext = SignInAccountStartupContext | 'CONFIRM_AUTHENTICATION' | 'OTHER';
